<!-- 改厕档案信息 -->
<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 2">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!--改厕档案管理，改厕档案审核-->
        <el-tab-pane v-for="item in tabList" :key="tabList.indexOf(item)" :label="item.label" :name="item.name"></el-tab-pane>
      </el-tabs>
      <div v-if="activeName === '1'">
        <!--查询区域-->
        <el-row class="margin-top-10">
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              区划:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <cascader :set-props="setProps" :set-size="GLOBAL.config.systemSize" maxlength="64" ref="myArea">
            </cascader>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕户姓名:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.hz" :size="GLOBAL.config.systemSize" placeholder="改厕户姓名" clearable maxlength="32"></el-input>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              身份证号:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.hzsfz" :size="GLOBAL.config.systemSize" placeholder="身份证号" clearable
              maxlength="32"></el-input>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              手机号码:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.hzsjh" :size="GLOBAL.config.systemSize" placeholder="手机号码" clearable
              maxlength="32"></el-input>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕类型:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-select v-model="searchForm.gclx" multiple placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;"
              clearable>
              <el-option v-for="item in dictionary.gclxs" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕模式:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-select v-model="searchForm.gczt" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;"
              clearable>
              <el-option v-for="item in dictionary.gczts" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕年份:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-date-picker type="year" placeholder="请选择" value-format="yyyy" v-model="searchForm.time" :size="GLOBAL.config.systemSize"
              style="width:100%;">
            </el-date-picker>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕编号:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.gcbh" :size="GLOBAL.config.systemSize" placeholder="改厕编号" clearable maxlength="32"></el-input>
          </el-col>

          <!--                <el-col :span="12" class="margin-top-10">-->
          <!--                  <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" style="float: right;" icon="el-icon-search">查询-->
          <!--                  </el-button>-->
          <!--                </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              清掏方式:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-select v-model="searchForm.qtfs" clearable placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;">
              <el-option v-for="item in dictionary.qtfss" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="14">&nbsp;</el-col>
          <el-col :span="2" class="margin-top-10">
              <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" style="float: right;" icon="el-icon-search">查询
              </el-button>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <el-button v-if="source.export" type="primary" icon="el-icon-upload2" :size="GLOBAL.config.systemSize"
                       style="float: right;" @click="exportTableData">查询导出
            </el-button>
          </el-col>
        </el-row>
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-button v-if="source.add" type="primary" icon="el-icon-plus" :size="GLOBAL.config.systemSize" style="float: left;"
              @click="operationMethod('add')">新增
            </el-button>
            <el-button v-if="source.deleteBatch" type="danger" icon="el-icon-delete" :size="GLOBAL.config.systemSize"
              style="float: left;" :disabled="deleteBatchList.ids.length === 0" @click="deleteBatch">批量删除
            </el-button>
            <el-button v-if="source.exportTemplate" type="primary" icon="el-icon-download" :size="GLOBAL.config.systemSize"
              style="float: left;" @click="exportTemplate">下载导入模板
            </el-button>
            <el-upload style="float:left;" class="upload-demo" accept=".xlsx,.xls" :action="url" :on-success="uploadSuccess"
              :data="data" :file-list="fileList" :show-file-list="false">
              <el-button icon="el-icon-upload2" type="primary" size="mini" style="margin: 0 15px">批量导入</el-button>
            </el-upload>
          </el-col>
        </el-row>

        <el-table style="width: 100%" :data="tableData" @selection-change="tableSelectionChange" element-loading-text="数据处理中...请稍等..."
          v-loading="loading">
          <el-table-column type="selection">
          </el-table-column>
          <!--序号-->
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column :label="showGC?'改厕户姓名':'公厕管理员'" prop="hz" align="center"></el-table-column>
          <el-table-column label="所属区划" prop="ssqhName" align="center"></el-table-column>
          <el-table-column :label="showGC?'改厕户身份证':'公厕管理员身份证'" prop="hzsfz" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.returnStarInfo(4, 14, scope.row.hzsfz)}}
            </template>
          </el-table-column>
          <el-table-column label="手机号码" prop="hzsjh" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.returnStarInfo(3, 7, scope.row.hzsjh)}}
            </template>
          </el-table-column>
          <el-table-column label="改厕年份" prop="gcrq" align="center"></el-table-column>
          <el-table-column label="改厕类型" prop="gczt" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.getConfigValue(scope.row.gczt, 'GC_TYPE')}}
            </template>
          </el-table-column>
          <el-table-column label="改厕模式" prop="gclx" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.getConfigValue(scope.row.gclx, 'GC_LX')}}
            </template>
          </el-table-column>
          <el-table-column label="清掏方式" prop="qtfs" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.getConfigValue(scope.row.qtfs, 'ZX_QT')}}
            </template>
          </el-table-column>
          <el-table-column :label="showGC?'改厕编号':'农村公厕编号'" prop="gcbh" align="center" width="150"></el-table-column>
          <el-table-column prop="scope" label="操作" align="center">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)" :key="item.method"
                    @click.native="handleCommon(item.method, scope.row)">
                    {{item.title}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="margin-top-10 margin-bottom-20" @size-change="tableSizeChange" @current-change="currentChange"
          :current-page="pagination.currentPage" :page-sizes="pagination.pageSizeList" :page-size="pagination.pageSize"
          :layout="pagination.layout" :total="pagination.total">
        </el-pagination>
        <gcarchivesinfoeditor ref="gcarchivesinfoeditor" :refresh="init" :close-self="()=> viewVisibleFlag = false" />
        <gcArchivesInfoImportErrorDialog ref="gcArchivesInfoImportErrorDialog" />
      </div>
      <div v-if="activeName === '2'">
        <!--查询区域-->
        <el-row class="margin-top-10">
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              改厕户姓名:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.hz" :size="GLOBAL.config.systemSize" placeholder="改厕户姓名" clearable maxlength="32"></el-input>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <label class="search-label">
              手机号码:
            </label>
          </el-col>
          <el-col :span="4" class="margin-top-10">
            <el-input v-model="searchForm.hzsjh" :size="GLOBAL.config.systemSize" placeholder="手机号码" clearable
              maxlength="32"></el-input>
          </el-col>
          <el-col :span="2" class="margin-top-10">
            <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
            </el-button>
          </el-col>
        </el-row>

        <el-table style="width: 100%" :data="tableData" @selection-change="tableSelectionChange" element-loading-text="数据处理中...请稍等..."
          v-loading="loading">
          <el-table-column type="selection">
          </el-table-column>
          <!--序号-->
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="改厕户姓名" prop="hz" align="center"></el-table-column>
          <el-table-column label="所属区划" prop="ssqhName" align="center"></el-table-column>
          <el-table-column label="手机号码" prop="hzsjh" align="center"></el-table-column>
          <el-table-column label="改厕年份" prop="gcrq" align="center"></el-table-column>
          <el-table-column label="改厕类型" prop="gczt" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.getConfigValue(scope.row.gczt, 'GC_TYPE')}}
            </template>
          </el-table-column>
          <el-table-column label="清掏方式" prop="qtfs" align="center">
            <template slot-scope="scope">
              {{FUNCTIONS.systemFunction.getConfigValue(scope.row.qtfs, 'ZX_QT')}}
            </template>
          </el-table-column>
          <el-table-column label="改厕编号" prop="gcbh" align="center" width="150"></el-table-column>
          <el-table-column prop="scope" label="操作" align="center">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)" :key="item.method"
                    @click.native="handleCommon(item.method, scope.row)">
                    {{item.title}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="margin-top-10 margin-bottom-20" @size-change="tableSizeChangeSH" @current-change="currentChangeSH"
          :current-page="paginationSH.currentPage" :page-sizes="paginationSH.pageSizeList" :page-size="paginationSH.pageSize"
          :layout="paginationSH.layout" :total="paginationSH.total">
        </el-pagination>
        <gcarchivesinfoeditor ref="gcarchivesinfoeditor" :refresh="init" :close-self="()=> viewVisibleFlag = false" />
        <gcArchivesInfoImportErrorDialog ref="gcArchivesInfoImportErrorDialog" />
      </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import cascader from '../../components/Cascader'
  import gcarchivesinfoeditor from './GCArchivesInfoEditDialog'
  import gcArchivesInfoImportErrorDialog from './GCArchivesInfoImportErrorDialog'
  export default {
    name: 'GCArchivesInfoTable',

    components: {
      cascader,
      gcarchivesinfoeditor,
      gcArchivesInfoImportErrorDialog
    },

    data() {
      return {
        showGC: true,
        tabList: [],
        activeName: '1',
        searchForm: {
          ssqh: '',
          hzsjh: '',
          hzsfz: '',
          hz: '',
          gclx: '',
          time: '',
          gcbh: '',
          qtfs: '',
          gczt: ''
        },
        dictionary: {
          // 改厕类型
          gclxs: JSON.parse(unescape(localStorage.getItem("GC_TYPE"))),
          // 清掏方式
          qtfss: JSON.parse(unescape(localStorage.getItem("ZX_QT"))),
          //改厕模式
          gczts: JSON.parse(unescape(localStorage.getItem("GC_LX")))

        },
        source: {
          add: true,
          deleteBatch: true,
          export: true,
          import: true,
          infoView: true,
          infoEdit: true,
          infoDelete: true,
          exportTemplate: true
        },
        loading: false,
        tableData: [],
        deleteBatchList: {
          ids: [],
          deleteFlag: false
        },
        // 分页参数
        pagination: {
          pageSizeList: [10, 20, 30, 40, 50],
          pageSize: 10,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          currentPage: 1
        },
        // 审核分页参数
        paginationSH: {
          pageSizeList: [10, 20, 30, 40, 50],
          pageSize: 10,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          currentPage: 1
        },
        // 所属区域
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        viewVisibleFlag: false,
        url: this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad + '/importVillageData',
        data: {},
        fileList: [],
        yhqx: ''
      }
    },

    methods: {
      hange2() {
        this.$forceUpdate()
      },
      handleClick(tab, event) {
        if (tab.name === '1') {
          setTimeout(() => {
            this.getTableData('init')
          }, 100)
          // this.getTableData('init')
        } else {
          this.getSHTableData('init')
        }
      },
      uploadSuccess(response, file, fileList) {
        // debugger
        // let {data,meta:{code}} = response;
        let code = response.code
        let data = response.data
        if (code == '0') {
          this.$message({
            type: 'success',
            message: '导入成功!'
          })
          this.getTableData('init')
        } else {
          this.$refs.gcArchivesInfoImportErrorDialog.open(data, '改厕档案导入错误提示')
        }
      },
      init: function() {
        if (this.activeName === '1') {
          this.getTableData('init')
        } else {
          this.getSHTableData('init')
        }
      },
      doSearch: function() {
        if (this.activeName === '1') {
          this.getTableData('init')
        } else {
          this.getSHTableData('init')
        }
        // this.getTableData('init')
      },

      // 新增
      operationMethod(addInfo, info) {
        this.$refs.gcarchivesinfoeditor.open(addInfo, info)
      },
      deleteBatch: function() {
        // debugger
        if (!this.deleteBatchList.ids || this.deleteBatchList.ids.length == 0) {
          return
        }
        let _this = this
        let param = {
          infos: _this.deleteBatchList.ids,
          // baseService: 'TGcGcdaServiceImpl',
          baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
          type: _this.GLOBAL.config.handleType.deletePhysical
        }
        _this.$confirm('确认删除当前选择的' + _this.deleteBatchList.ids.length + '条数据？', '提示', {}).then(() => {
          _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            param,
            resultData => {
              _this.loading = false
              if (resultData) {
                _this.$message.success('删除成功～')
                _this.getTableData('init')
              } else {
                _this.$message.warning('删除失败～')
              }
            }
          )
        })
      },
      // 获取操作展示
      getSource: function(rowData) {
        let tempList = []
        if (this.activeName === '1') {
          this.source.infoView && tempList.push({
            icon: 'el-icon-view',
            title: '查看',
            method: 'handleView'
          })
          this.source.infoEdit && tempList.push({
            icon: 'el-icon-edit',
            title: '编辑',
            method: 'handleEdit'
          })
          this.source.infoDelete && tempList.push({
            icon: 'el-icon-delete',
            title: '删除',
            method: 'handleDelete'
          })
        } else if (this.activeName === '2') {
          this.source.infoView && tempList.push({
            icon: 'el-icon-view',
            title: '查看',
            method: 'handleView'
          })
          if (rowData.zt === '0') {
            this.source.infoView && tempList.push({
              icon: 'el-icon-circle-check',
              title: '审核通过',
              method: 'handleApprT'
            })
            this.source.infoView && tempList.push({
              icon: 'el-icon-circle-close',
              title: '审核驳回',
              method: 'handleApprB'
            })
          }
          if (rowData.dwsh === '0' || !rowData.dwsh) {
            this.source.infoView && tempList.push({
              icon: 'el-icon-position',
              title: '定位审核',
              method: 'handleApprDw'
            })
          }
        }
        return tempList
      },
      handleCommon: function(type, rowData) {
        switch (type) {
          case 'handleView':
            this.handleView(rowData)
            break
          case 'handleEdit':
            this.handleEdit(rowData)
            break
          case 'handleDelete':
            this.handleDelete(rowData)
            break
          case 'handleApprT':
            this.handleAppr(rowData, '1', true)
            break
          case 'handleApprB':
            this.handleAppr(rowData, '2', true)
            break
          case 'handleApprDw':
            this.handleAppr(rowData, '1', false)
            break
        }
      },
      // 审核
      handleAppr: function(rowData, zt, type) {
        let _this = this
        let param = {}
        if (type === true) {
          param = {
            info: {
              uuid: rowData.uuid,
              zt: zt
            },
            baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
            type: 'registerInfo'
          }
        } else {
          param = {
            info: {
              uuid: rowData.uuid,
              dwsh: zt
            },
            baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
            type: 'registerInfo'
          }
        }
        let status = zt;
        this.$confirm('是否审核' + (zt === '1' ? '通过' : '驳回') + rowData.hz + '的档案' + (type == true ? '' : '定位') + '信息？',
          type == true ? '提示' : ('定位地址：' + rowData.dwdz), {}).then(() => {
          _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            param,
            resultData => {
              _this.loading = false
              if (resultData) {
                const text = status === '1' ? '审核成功' : '驳回成功';
                _this.$message.success(text)
                _this.getSHTableData('init')
              } else {
                _this.$message.warning('审核失败～')
              }
            }
          )
        })
      },
      // 查看
      handleView: function(rowData) {
        this.$router.push({
          name: 'GCArchivesInfo',
          params: {
            type: 'view',
            gcArchivesInfo: rowData
          }
        })
      },
      // 编辑
      handleEdit: function(rowData) {
        this.$refs.gcarchivesinfoeditor.open('edit', rowData)
      },
      handleDelete: function(rowData) {
        let _this = this
        let param = {
          info: rowData.uuid,
          // baseService: 'TGcGcdaServiceImpl',
          baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
          type: _this.GLOBAL.config.handleType.deleteLogical
        }
        _this.$confirm('确认删除当前数据？？', '提示', {}).then(() => {
          _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            param,
            resultData => {
              _this.loading = false
              if (resultData) {
                _this.$message.success('删除成功～')
                _this.getTableData('init')
              } else {
                _this.$message.warning('删除失败～')
              }
            }
          )
        })
      },
      // 获取列表
      getTableData: function(initPageFlag) {
        this.loading = true
        let _this = this
        // 3、 调接口获取数据
        let param = {
          // baseService : "TGcGcdaServiceImpl",
          baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
          current: initPageFlag ? 1 : _this.pagination.currentPage,
          size: initPageFlag ? 10 : _this.pagination.pageSize,
          records: []

        }
        let condition = {}
        if (_this.$refs.myArea&&_this.$refs.myArea.sendToParent('value')) {
          condition.ssqh = _this.$refs.myArea.sendToParent('value')
        }
        if (_this.searchForm.hzsfz) {
          condition.hzsfz = _this.searchForm.hzsfz
        }
        if (_this.searchForm.hzsjh) {
          condition.hzsjh = _this.searchForm.hzsjh
        }
        if (_this.searchForm.hz) {
          condition.hz = _this.searchForm.hz
        }
        if (_this.searchForm.gclx) {
          condition.gclx = _this.searchForm.gclx.toString()
        }
        if (_this.searchForm.gczt) {
          condition.gczt = _this.searchForm.gczt.toString()
        }
        if (_this.searchForm.time) {
          condition.time = _this.searchForm.time
        }
        if (_this.searchForm.gcbh) {
          condition.gcbh = _this.searchForm.gcbh
        }
        if (_this.searchForm.qtfs) {
          condition.qtfs = _this.searchForm.qtfs.toString()
        }
        if (condition.ssqh || _this.searchForm.hzsjh || _this.searchForm.hzsfz || _this.searchForm.hz || _this.searchForm
          .gclx || _this.searchForm.gczt || _this.searchForm.time || _this.searchForm.gcbh || _this.searchForm.qtfs) {
          param.records = [ _this.FUNCTIONS.systemFunction.removeNullFields(condition)]
        } else {
          param.records = [{}]
        }
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          _this.GLOBAL.config.handleType.getPage,
          param,
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              // 结果参数赋值
              _this.tableData = resultData.obj.records
              _this.pagination.pageSize = resultData.obj.size
              _this.pagination.total = resultData.obj.total
              _this.pagination.currentPage = resultData.obj.current
              if (_this.searchForm.gclx !== '4') {
                _this.showGC = true
              } else {
                _this.showGC = false
              }
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      getSHTableData: function(initPageFlag) {
        this.loading = true
        let _this = this
        // 3、 调接口获取数据
        let param = {
          // baseService : "TGcGcdaServiceImpl",
          baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
          current: initPageFlag ? 1 : _this.paginationSH.currentPage,
          size: initPageFlag ? 10 : _this.paginationSH.pageSize,
          records: []

        }
        let condition = {}
        if (_this.searchForm.hzsjh) {
          condition.hzsjh = _this.searchForm.hzsjh
        }
        if (_this.searchForm.hz) {
          condition.hz = _this.searchForm.hz
        }
        if (_this.searchForm.hzsjh || _this.searchForm.hz) {
          param.records = [condition]
        } else {
          param.records = [{}]
        }
        _this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          _this.GLOBAL.config.handleType.getPageNew,
          param,
          null,
          resultData => {
            _this.loading = false
            if (resultData) {
              // 结果参数赋值
              _this.tableData = resultData.obj.records
              _this.paginationSH.pageSize = resultData.obj.size
              _this.paginationSH.total = resultData.obj.total
              _this.paginationSH.currentPage = resultData.obj.current
            } else {
              _this.$message.warning('获取列表数据失败～')
            }
          },
          () => {
            _this.loading = false
          }
        )
      },
      // 分页方法
      tableSizeChange: function(pageSize) {
        this.pagination.pageSize = pageSize
        this.getTableData()
      },
      currentChange: function(current) {
        this.pagination.currentPage = current
        this.getTableData()
      },
      // 复选框选择事件
      tableSelectionChange: function(targetList) {
        let ids = []
        targetList.forEach(item => {
          ids.push(item.uuid)
        })
        this.deleteBatchList.ids = ids
        if (this.deleteBatchList.ids &&
          this.deleteBatchList.ids.length > 0) {
          this.deleteBatchList.deleteFlag = true
        } else {
          this.deleteBatchList.deleteFlag = false
        }
      },
      // 分页方法
      tableSizeChangeSH: function(pageSize) {
        this.paginationSH.pageSize = pageSize
        this.getSHTableData()
      },
      currentChangeSH: function(current) {
        this.paginationSH.currentPage = current
        this.getSHTableData()
      },
      // 列表数据导出
      exportTableData: function() {
		  if (this.activeName === '1') {
		    this.getTableData('init')
		  } else {
		    this.getSHTableData('init')
		  }
        let condition = {}
        if (this.$refs.myArea.sendToParent('value')) {
          condition.ssqh = this.$refs.myArea.sendToParent('value')
        } else {
          condition.ssqh = ''
        }
        if (this.searchForm.hzsfz) {
          condition.hzsfz = this.searchForm.hzsfz
        } else {
          condition.hzsfz = ''
        }
        if (this.searchForm.hzsjh) {
          condition.hzsjh = this.searchForm.hzsjh
        } else {
          condition.hzsjh = ''
        }
        if (this.searchForm.hz) {
          condition.hz = this.searchForm.hz
        } else {
          condition.hz = ''
        }
        if (this.searchForm.gclx) {
          condition.gclx = this.searchForm.gclx.toString()
        } else {
          condition.gclx = ''
        }
        if (this.searchForm.gczt) {
          condition.gczt = this.searchForm.gczt.toString()
        } else {
          condition.gczt = ''
        }
        if (this.searchForm.time) {
          condition.time = this.searchForm.time.toString()
        } else {
          condition.time = ''
        }

		if (this.searchForm.gcbh) {
		  condition.gcbh = this.searchForm.gcbh.toString()
		} else {
		  condition.gcbh = ''
		}
		if (this.searchForm.qtfs) {
		  condition.qtfs = this.searchForm.qtfs.toString()
		} else {
		  condition.qtfs = ''
		}
        // let keyArr = [];
        // let valueArr = [];
        // for (let key in params) {
        //     keyArr.push(key);
        //     valueArr.push(params[key]);
        // }
        let params = '&ssqh=' + condition.ssqh + '&hz=' + condition.hz + '&hzsjh=' + condition.hzsjh + '&gclx=' +
          condition.gclx + '&time=' + condition.time + '&gczt=' + condition.gczt + '&gcbh=' + condition.gcbh+ '&qtfs=' + condition.qtfs + '&hzsfz=' + condition.hzsfz

        window.location.href = this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad +
          '/exportTGcGcda?requestBean=' + JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm + params
      },
      // 下载导入模板
      exportTemplate: function() {
        window.location.href = this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad + '/exportTGcGcdaTemplate'
      },
      importTableData: function() {
        // TODO
      }
    },
    mounted() {
      this.yhqx = JSON.parse(localStorage.getItem('gcUserInfo')).yhqx
      if (this.yhqx === '3') {
        this.tabList = [{
          label: '改厕档案管理',
          name: '1'
        }]
      } else {
        this.tabList = [{
          label: '改厕档案管理',
          name: '1'
        }, {
          label: '改厕档案审核',
          name: '2'
        }]
      }
      this.init()
    }
  }
</script>

<style scoped>
  .upload-demo {
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/GCArchivesInfo/GCArchivesInfoTable.vue